import React, { useEffect, useState } from "react";

import cross from "../../assets/images/SiteImg/cross.png";
import { ThreeDots } from "react-loader-spinner";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { AddAttorneyAssociate, AddJointUser, getAttCode, getCounty, getDistrict, getStates, UpdateUserInfor, userinfo, VerifyUser } from "../../api/server";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../store/userSlice";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import DisclosureModal from "./DisclosureModal";
import CollectInfoSelect from "./CollectInfoSelect";
import "./CollectInfo.css";
import { FiEye, FiEyeOff } from "react-icons/fi";

const CollectInfoModal = ({
    userData,
    // userId,
}) => {
    const [noCode, setNoCode] = useState(false);
    const [userAttorney, setUserAttorney] = useState();
    const [readOnly, setReadOnly] = useState(false);
    const [atternyName, setAtternyName] = useState("");
    const [atternyEmail, setAtternyEmail] = useState("");
    const [atternyNumber, setAtternyNumber] = useState("");
    const [attCodeValidation, setattCodeValidation] = useState(false);
    const [attorneyInfoAdded, setAttorneyInfoAdded] = useState(false);
    const [jointFilerInfoAdded, setJointFilerInfoAdded] = useState(false);
    const [jointReadOnly , setJointReadOnly] = useState(false)

    // const userData = useSelector((state) => state.user);
    // const [userData, setuserData] = useState()
    const loginUserData = useSelector((state) => state.user);
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const courseValue = queryParams.get("course");
    const redirection = queryParams.get("redirect") ? queryParams.get("redirect")  : false;

    const retake = Boolean(
        queryParams.get("retake") !== null &&
        queryParams.get("retake") != "null" &&
        queryParams.get("retake") != "false" &&
        queryParams.get("retake") !== false
    );
    const userId = queryParams.get("id");
    

    // useEffect(() => {
    //     userinfo(userData.user.data.id)
    //       .then((res) => {
    //         console.log("lkjaklsjf",res?.data?.data)
    //         setuserData(res?.data?.data)
    //         // setLoading(false)
    //       })
    //       .catch((err) => {
    //         setuserData()
    //         // setLoading(false)
    //       });
    //   }, []);
    const [loading, setLoading] = useState(false)
    const [loadingJointFiler, setLoadingJointFiler] = useState(false)
    const [loadingAttorney, setLoadingAttorney] = useState(false)

    const [verifyCodeloading, setVerifyCodeloading] = useState(false)
    const dispatch = useDispatch();
    const [selectedCounty, setSelectedCounty] = useState("");
    const [selectedState, setSelectedState] = useState("");
    const [countiesData, setCountiesData] = useState([]);
    const [districtsData, setDistrictsData] = useState([]);
    const [statesData, setStatesData] = useState([]);
    const [selectedDistrict, setSelectedDistrict] = useState("");
    const [showDisclosureModal, setShowDisclosureModal] = useState(false);
    const [showAttymPass, setShowAttymPass] = useState(false);
    const [showJointFiler, setShowJointFiler] = useState(false);
    console.log("redirection>>>>>>>", redirection)
    console.log("userDatauserDataasd",courseValue,courseValue == "first" ,userData?.judicialdistrict_state_second
    )
    const handleCheckboxChange = (e) => {
        setShowJointFiler(e.target.checked);
      };

      
      
    const initialValues = {
        agreeToBankruptcy: false,
        ssnLastFour: userData?.ssn || "",
        attorneyEmail: userData?.attyemail || "",
        attorneyName: userData?.attorneyname || "",
        attorneyPhone: userData?.attyphone || "",
        filingState: courseValue == "first" ?  userData?.judicialdistrict_state_first :
                                               userData?.judicialdistrict_state_second ,
        filingCounty: courseValue == "first" ? userData?.judicialdistrict_county_first : 
                                               userData?.judicialdistrict_county_second,
        filingDistrict: courseValue == "first" ? userData?.judicialdistrict_first :
                                                 userData?.judicialdistrict_second,
        phone: userData?.phone || "",
        firstname: userData?.firstname || "",
        middleinitial: userData?.middleinitial || "",
        lastname: userData?.lastname || "",
        address1: userData?.addr1 || "",
        address2: userData?.addr2 || "",
        city: userData?.city || "",
        state: userData?.state || "",
        zip: userData?.zip || "",
        attycode:userData?.couponcode_first,
        isJointFiler: userData?.joint_firstname ? true :false,
        jointFiler_firstName: userData?.joint_firstname,
        joint_dob: userData?.joint_dob ? userData?.joint_dob.split("T")[0] : "",
      jointFiler_middleInitial: userData?.joint_middleinitial,
      jointFiler_lastName: userData?.joint_lastname,
      jointFiler_ssn: userData?.joint_ssn,
    //   joint_dlnum: userData?.joint_dlnum,
      jointFiler_username: userData?.joint_username,
      jointFiler_password: userData?.joint_password,
    };
    useEffect(() => {
        if (userData) {
            setAtternyEmail(userData?.attyemail)
            setAtternyNumber(userData?.attyphone)
            setAtternyName(userData?.attorneyname)
            setSelectedCounty(courseValue == "first" ? userData?.judicialdistrict_county_first : 
                userData?.judicialdistrict_county_second)
            setSelectedState(courseValue == "first" ?  userData?.judicialdistrict_state_first :
                userData?.judicialdistrict_state_second)
            setSelectedDistrict(courseValue == "first" ? userData?.judicialdistrict_first :
                userData?.judicialdistrict_second)
            if(userData?.couponcode_first){
                setUserAttorney(userData?.couponcode_first)
                setReadOnly(true)
                setAttorneyInfoAdded(true)
            }
        }
        if(userData?.joint_username){
            setShowJointFiler(true)
            setJointReadOnly(true)
            setJointFilerInfoAdded(true)
        }
    }, [userData])
    const ValidationSchema = Yup.object().shape({
        ssnLastFour: Yup.string().required("Last Four Digits of SSN is required").matches(/^\d{4}$/, "SSN must be exactly 4 digits"),
        filingState: Yup.string().required("State is required"),
        filingCounty: Yup.string().required("Country is required"),
        filingDistrict: Yup.string().required("District is required"),
        phone: Yup.string().required("Phone number is required"),
        firstname: Yup.string().required("First Name is required"),
        middleinitial: Yup.string(),
        lastname: Yup.string().required("Last Name is required"),
        address1: Yup.string().required("Address Line 1 is required"),
        address2: Yup.string(),
        city: Yup.string().required("City is required"),
        state: Yup.string().required("State is required"),
        zip: Yup.number().required("Zip Code is required"),

        attycode: Yup.string().required("Attorney Code is required"),
        attorneyEmail: Yup.string().email("Invalid email").required("Your Email is required"),
        attorneyName: Yup.string().required("Attorney Name is required"),
        attorneyPhone: Yup.string().required("Attorney Phone is required"),
        
        jointFiler_firstName: showJointFiler
        ? Yup.string().required("First name is required")
        : Yup.string(),
        joint_dob: showJointFiler
        // ? Yup.string().required("Date of Birth is required")
        ? Yup.string()
        : Yup.string(),
      jointFiler_lastName: showJointFiler
        ? Yup.string().required("Last name is required")
        : Yup.string(),
      jointFiler_ssn: showJointFiler
        ? Yup.string().required("SSN is required").matches(/^\d{4}$/, "SSN must be exactly 4 digits")
        : Yup.string(),
    //   joint_dlnum: showJointFiler
    //     ? Yup.string().required("Phone Number is required")
    //     : Yup.string(),
      jointFiler_username: showJointFiler
              ? Yup.string().required("Username is required")
              : Yup.string(),
            jointFiler_password: showJointFiler
              ? Yup.string()
                  .required("Password is required")
                  .min(8, "Password must be at least 8 characters")
                  .matches(
                    /[A-Z]/,
                    "Password must contain at least one uppercase character"
                  )
              : Yup.string()
                  .min(8, "Password must be at least 8 characters")
                  .matches(
                    /[A-Z]/,
                    "Password must contain at least one uppercase character"
                  ),
    });

    console.log("userDatauserData", userData)
    function valuesSetter(data) {
        setAtternyEmail(data.email);
        setAtternyName(data?.firstname);
        setAtternyNumber(data?.phone);
    }

   
    const handleSubmit = async (values, { resetForm }) => {
        setLoading(true);
        let payload = { ...values };
        //   if (readOnly) {
        //     payload.attycode = userAttorney;
        //   }
        if(!userData?.couponcode_first){
            payload.attycode = userAttorney
            payload.attorneyPhone = atternyNumber;
            payload.attorneyEmail = atternyEmail;
            payload.attorneyName = atternyName;
        }
        else{
            payload.attycode = ""
            payload.attorneyPhone = "";
            payload.attorneyEmail = "";
            payload.attorneyName = "";
        }
        if(courseValue === "first"){
            payload.course = "first_course"
        }
        if(courseValue === "second"){
            payload.course = "second_course"
        }
        console.log("Form Submitted:", payload,values);
        await UpdateUserInfor(payload, userData.id).then((res) => {
            if (res?.status == "200") {
                dispatch(login(res.data));
                toast.success("Form submitted successfully!");
                // closeModal()
                // setShowModal(false)
                setLoading(false);
                // if(courseValue == "first"){
                //     navigate(`/contactwithcounselor?completed=${courseValue}&retake=${retake}`)
                // }
                // else{
                //     navigate(`/congratulationmessage`)   
                // }
                console.log("courseValue>>>>>>",courseValue)
                if(courseValue == "first"){
                    if(redirection){
                        navigate(`/contactwithcounselor?completed=${courseValue}&retake=${retake}`)
                    }
                    else{
                        navigate(`/course`)
                    }
                }
                else{
                    if(redirection){
                        navigate(`/congratulationmessage`)
                    }
                    else{
                        navigate(`/2nd-course`)

                    }
                }
               
                
            }

        })
            .catch((err) => {
                toast.success("There is some error");

                setLoading(false);
            });

    };

    useEffect(() => {
        const fetchStatesData = async () => {
            try {
                const response = await getStates();
                const data = response.data;
                setStatesData(data);
            } catch (error) {
                console.error("Error fetching states data:", error);
            }
        };
        fetchStatesData();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            setCountiesData([]);
            try {
                if (selectedState) {
                    /////////////////////// get data of county////////////////
                    const response = await getCounty({ state: selectedState });
                    const countiesData = response.data;
                    setCountiesData(countiesData);
                }
            } catch (error) { }
        };

        fetchData();
    }, [selectedState]);

    useEffect(() => {
        const fetchData = async () => {
            setDistrictsData([]);
            try {
                if (selectedCounty) {
                    /////////////////////// get data of District////////////////
                    const districtResponse = await getDistrict({
                        state: selectedState,
                        county: selectedCounty,
                    });
                    const distData = districtResponse.data;

                    setDistrictsData(distData);
                }
            } catch (error) { }
        };

        fetchData();
    }, [selectedCounty]);


    const handleClose = () => {
        console.log("testing")
        // setShowModal(false)
      }


      const mainFieldsOnly = [
        "ssnLastFour", "filingState", "filingCounty", "filingDistrict",
        "phone", "firstname", "middleinitial", "lastname",
        "address1", "address2", "city", "state", "zip"
      ];
    
      const attorneyFieldsOnly = ["attycode"];
      const attorneyRelatedFields = ["attorneyEmail","attorneyName","attorneyPhone"]
    
      const jointFilerFieldsOnly = [
        "jointFiler_firstName", "jointFiler_middleInitial", "jointFiler_lastName","joint_dob",
        "jointFiler_ssn", "jointFiler_username", "jointFiler_password"
      ];

      const validateFieldsSubset = async (schema, values, fieldNames) => {
        try {
          const subset = Object.fromEntries(
            Object.entries(values).filter(([key]) => fieldNames.includes(key))
          );
      
          const partialSchema = Yup.object().shape(
            Object.fromEntries(fieldNames.map((key) => [key, schema.fields[key]]))
          );
      
          await partialSchema.validate(subset, { abortEarly: false });
      
          return { isValid: true };
        } catch (err) {
          return { isValid: false, errors: err.inner };
        }
      };  
 const handleVerifyAttorney = async (values, setErrors, setTouched,) => {
      const result = await validateFieldsSubset(ValidationSchema, values, attorneyFieldsOnly);
        console.log("result>>>>>>.", result, ValidationSchema, values,attorneyFieldsOnly);
      
        if (!result.isValid) {
          const formattedErrors = {};
          const touchedFields = {};

            result.errors.forEach(e => {
            if (attorneyFieldsOnly.includes(e.path)) {
              formattedErrors[e.path] = e.message;
              touchedFields[e.path] = true;
            }
          });
         
         
      console.log("formattedErrors",touchedFields,formattedErrors)
          setErrors(formattedErrors);
          setTouched(touchedFields); // Set all relevant fields as touched
          return;
        }
        setattCodeValidation(false);
        // e.preventDefault();
        const body = {
            code: userAttorney ? userAttorney : userData?.couponcode_first,
        };
        console.log("askjdfkjasfdh",body)
        try {
            setVerifyCodeloading(true);
            const response = await VerifyUser(body);
            if (response.status === 200) {
                setReadOnly(true);
                const data = response.data;
                valuesSetter(response?.data?.data);
                toast.success("Attorney information verified successfully!");
                setVerifyCodeloading(false);
            } else {
                setattCodeValidation(true);
            }
        } catch (error) {
            setattCodeValidation(true);
            console.error("Error fetching states data:", error);
            setVerifyCodeloading(false);
        }
    };
      const handleAddAttorney = async (values, setErrors, setTouched,noCode = false) => {
        const result = await validateFieldsSubset(ValidationSchema, values, noCode ?  attorneyRelatedFields : attorneyFieldsOnly);
        console.log("result>>>>>>.", result, ValidationSchema, values, attorneyRelatedFields);
      
        if (!result.isValid) {
          const formattedErrors = {};
          const touchedFields = {};
      
          if(noCode){
           result.errors.forEach(e => {
            if (attorneyRelatedFields.includes(e.path)) {
              formattedErrors[e.path] = e.message;
              touchedFields[e.path] = true;
            }
          });
          }else{
            result.errors.forEach(e => {
            if (attorneyFieldsOnly.includes(e.path)) {
              formattedErrors[e.path] = e.message;
              touchedFields[e.path] = true;
            }
          });
          }
         
      console.log("formattedErrors",touchedFields,formattedErrors)
          setErrors(formattedErrors);
          setTouched(touchedFields); // Set all relevant fields as touched
          return;
        }
        const payload = {
            id: userData.id,

            
            course: courseValue == "first" ? "CC" : "DE",
            couponcode_first: courseValue == "first" ? values?.attycode : userData?.couponcode_first  ,
            couponcode_second: courseValue == "second" ? values?.attycode : userData?.couponcode_second,


            paid_first: userData.paid_first,
            paid_second: userData.paid_second,
            attyemail: atternyEmail,
            attorneyname: atternyName,
            attyphone: atternyNumber,
            courseFirstEnrol: courseValue == "first" ? true : false,
            courseSecondEnroll: courseValue == "first" ? false : true,
           
          };
         if(!readOnly && !noCode){
            toast.error("To continue, please verify the Attorney Code.")
            return
         }

        // if(readOnly){
          console.log("call api here >>>..att",payload)
          setLoadingAttorney(true);
          await AddAttorneyAssociate(payload).then((res) => {
            console.log("lkdslkfas",res)
              if (res?.status == "200") {
                  toast.success("Added Attorney successfully!");
                  setLoadingAttorney(false);
              setAttorneyInfoAdded(true)

              }
              
          })
              .catch((err) => {
                // console.log("error<<",err)
                  toast.error(err.response.data.error || "There is some error");
  
                  setLoadingAttorney(false);
              });
        // }
      
        // continue with API submission if needed
      };

      const handleAddJointFiler = async (values, setErrors, setTouched) => {
        const result = await validateFieldsSubset(ValidationSchema, values, jointFilerFieldsOnly);
      
        if (!result.isValid) {
            const formattedErrors = {};
            const touchedFields = {};
          
            result.errors.forEach(e => {
              if (jointFilerFieldsOnly.includes(e.path)) {
                formattedErrors[e.path] = e.message;
                touchedFields[e.path] = true;
              }
            });
          
            setErrors(formattedErrors);
            setTouched(touchedFields);
            return;
          }
          
        const payload = {
          id: userData.id,
          joint_firstname: values.jointFiler_firstName,
          joint_middleInitial: values.jointFiler_middleInitial,
          joint_lastname: values.jointFiler_lastName,
          joint_ssn: values.jointFiler_ssn,
        //   joint_dlnum: values.joint_dlnum,
          joint_username: values.jointFiler_username,
          joint_password: values.jointFiler_password,
          joint_dob: values.joint_dob,

        };
      
        console.log("call api here >>>..joint",payload)

        setLoadingJointFiler(true);
        await AddJointUser(payload, userData.id).then((res) => {
            console.log("resresres>>>",res)
            if (res?.data?.sucess == true) {
                toast.success("Add Joint Filer successfully!");
                setLoadingJointFiler(false);
                setJointFilerInfoAdded(true)
                setJointReadOnly(true)
            }

        })
            .catch((err) => {
                toast.error("There is some error");

                setLoadingJointFiler(false);
            });

      };
    
      const submitMainForm = async (values, setErrors, setTouched) => {
        
        const result = await validateFieldsSubset(ValidationSchema, values, mainFieldsOnly);
        
        if (!result.isValid) {
            const formattedErrors = {};
            const touchedFields = {};
          
            result.errors.forEach(e => {
              if (mainFieldsOnly.includes(e.path)) {
                formattedErrors[e.path] = e.message;
                touchedFields[e.path] = true;
              }
            });
          
            setErrors(formattedErrors);
            setTouched(touchedFields);
            toast.error("You're missing some info. Please review the form.");
            return;
          }
         
          const payload = {
            agreeToBankruptcy: values?.agreeToBankruptcy,
            ssnLastFour: values?.ssnLastFour,
            filingState: values?.filingState,
            filingCounty: values?.filingCounty,
            filingDistrict: values?.filingDistrict,
            phone: values?.phone,
            firstname: values?.firstname,
            middleinitial: values?.middleinitial,
            lastname: values?.lastname,
            address1: values?.address1,
            address2:values?.address2,
            city: values?.city,
            state: values?.state,
            zip: values?.zip,
            course:  courseValue == "first" ? "first_course" : "second_course"
          };

          setLoading(true);
        
          
          console.log("call api here >>>..main",payload)

          await UpdateUserInfor(payload, userData.id ,loginUserData?.user?.data?.type  ).then((res) => {
              if (res?.status == "200") {
                if(loginUserData?.user?.data?.type !== "Admin"){
                  dispatch(login(res.data));

                }
                  toast.success("Form submitted successfully!");
                 
                  setLoading(false);
                  // if(courseValue == "first"){
                  //     navigate(`/contactwithcounselor?completed=${courseValue}&retake=${retake}`)
                  // }
                  // else{
                  //     navigate(`/congratulationmessage`)   
                  // }
                  console.log("courseValue>>>>>>",courseValue)
                  if(courseValue == "first"){
                    if(redirection){
                        navigate(`/contactwithcounselor?completed=${courseValue}&retake=${retake}`)
                    }
                    else{
                        if(loginUserData?.user?.data?.type === "Admin"){
                        navigate(`/user-first-course?id=${userData.id}`)

                        }
                        else{
                        navigate(`/course`)
                        }
                      
                    }
                }
                else{
                    if(redirection){
                        navigate(`/congratulationmessage`)
                    }
                    else{
                         if(loginUserData?.user?.data?.type === "Admin"){
                        navigate(`/user-second-course?id=${userData.id}`)

                        }
                        else{
                        navigate(`/2nd-course`)
                        }
                        

                    }
                }
                 
                  
              }
  
          })
              .catch((err) => {
                  toast.error("There is some error");
  
                  setLoading(false);
              });

      };






    
    return (
      <div>
        {/* <Modal size="xl" show={showModal} onHide={() => setShowModal(false)} className="collect-info-modal-container"> */}
        {/* <Modal.Header closeButton>
                    
                </Modal.Header> */}
        {/* <div className="d-flex justify-content-end p-2">
        <button className="btn-close" onClick={handleClose}></button>
    </div> */}
        {/* <Modal.Body > */}
        {/* <h1 className="" style={{ fontSize: '17px', padding: '0px 4px 20px 4px',  }}>
                        Please confirm your attorney's contact details so that we can send your certificate to your attorney.
                    </h1> */}
        <div className="modal_content btn_wrap collect-info-panel">
          <Formik
            initialValues={initialValues}
            // onSubmit={handleSubmit}
            // onSubmit={submitMainForm}
            validationSchema={ValidationSchema}
            enableReinitialize={true}
          >
            {({ values, setValues, errors, setErrors, setTouched }) => (
              <Form
                className="form-container collect-info-form"
              >
                <div className="row">
                  {/* Checkbox */}
                  {console.log("errorserrors", values)}
                  <div className="head ">
                    <h2 className="f18">Your Profile</h2>
                  </div>
                  <div className="row mt-40">
                    <div className="col-lg-6 col-md-6">
                      <div className="input_wrap">
                        <label className="label-title">First Name</label>
                        {console.log(
                          "userData?.firstname",
                          userData?.firstname,
                          !!userData?.firstname
                        )}
                        <Field
                          type="text"
                          name="firstname"
                          className="form-control"
                          placeholder="Enter first name"

                          // defaultValue={userData?.firstname || ""}
                          // readOnly={!!userData?.firstname}
                        />
                        <ErrorMessage
                          name="firstname"
                          component="div"
                          className="error text-danger"
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="input_wrap">
                        <label className="label-title">Middle Initial</label>
                        <Field
                          type="text"
                          name="middleinitial"
                          className="form-control"
                          placeholder="Enter middle initial"
                          // defaultValue={userData?.middleinitial || ""}
                          // readOnly={!!userData?.middleinitial}
                        />
                        <ErrorMessage
                          name="middleinitial"
                          component="div"
                          className="error text-danger"
                        />
                      </div>
                    </div>

                    <div className="col-lg-6 col-md-6">
                      <div className="input_wrap">
                        <label className="label-title">Last Name</label>
                        <Field
                          type="text"
                          name="lastname"
                          className="form-control"
                          placeholder="Enter last name"

                          // readOnly={!!userData?.lastname}
                        />
                        <ErrorMessage
                          name="lastname"
                          component="div"
                          className="error text-danger"
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="input_wrap">
                        <label className="label-title">Phone Number</label>
                        <Field
                          type="text"
                          className="form-control"
                          name="phone"
                          placeholder="Enter your phone no."
                          //  defaultValue={userData?.phone || ""}
                        />
                        <ErrorMessage
                          name="phone"
                          component="div"
                          className="error-message text-danger"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div
                      className="input_wrap"
                      style={{ marginBottom: "10px" }}
                    >
                      <label className="label-title">
                        Last Four Digits of SSN
                      </label>
                      <Field
                        type="text"
                        name="ssnLastFour"
                        className="form-control"
                        placeholder="Enter last four digits of SSN"
                      />
                      <ErrorMessage
                        name="ssnLastFour"
                        component="div"
                        className="error text-danger"
                      />
                    </div>
                  </div>
                  <p className="collect-info-privacy">
                    {/* The Bankruptcy Code requires a certificate to verify course completion, which includes identifying information like your Social Security Number (SSN). We use your SSN to ensure accurate reporting and compliance with these legal requirements. Rest assured, your information is handled securely and used only for this purpose. */}
                    Per the Bankruptcy Code, your certificate must include
                    identifying details like the last four digits of your Social
                    Security Number. We use your SSN to make sure your records
                    are accurate and meet legal requirements. Your information
                    is kept secure and used only for this purpose.
                  </p>
                  <div className="head mt-40">
                    <h2 className="f18">Your Contact Info</h2>
                  </div>
                  <div className="row mt-40">
                    <div className="col-lg-6 col-md-6">
                      <div className="input_wrap">
                        <label className="label-title">Address Line 1</label>
                        <Field
                          type="text"
                          className="form-control"
                          name="address1"
                          placeholder="Enter your address"
                        />
                        <ErrorMessage
                          name="address1"
                          component="div"
                          className="error-message text-danger"
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="input_wrap">
                        <label className="label-title">Address Line 2</label>
                        <Field
                          type="text"
                          className="form-control"
                          name="address2"
                          placeholder="Enter your address"
                        />
                        <ErrorMessage
                          name="address2"
                          component="div"
                          className="error-message text-danger"
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="input_wrap">
                        <label className="label-title">City</label>
                        <Field
                          type="text"
                          className="form-control"
                          name="city"
                          placeholder="Enter your city"
                        />
                        <ErrorMessage
                          name="city"
                          component="div"
                          className="error-message text-danger"
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="input_wrap">
                        <label className="label-title">State</label>
                        <Field name="state">
                          {({ field }) => (
                            <CollectInfoSelect
                              {...field}
                              onChange={(e) => {
                                setValues({
                                  ...values,
                                  state: e.target.value,
                                });
                              }}
                              className="form-control"
                            >
                              {statesData.length > 0 && (
                                <option value="">Select a State</option>
                              )}

                              {statesData.length > 0 ? (
                                statesData.map((state, index) => (
                                  <option key={index} value={state.state}>
                                    {state.state}
                                  </option>
                                ))
                              ) : (
                                <option value="">Loading...</option>
                              )}
                            </CollectInfoSelect>
                          )}
                        </Field>
                        <ErrorMessage
                          name="state"
                          component="div"
                          className="error text-danger"
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="input_wrap">
                        <label className="label-title">Zip Code</label>
                        <Field
                          type="text"
                          className="form-control"
                          name="zip"
                          placeholder="Enter zip code"
                        />
                        <ErrorMessage
                          name="zip"
                          component="div"
                          className="error-message text-danger"
                        />
                      </div>
                    </div>
                  </div>
                  {!userData?.couponcode_first && (
                    <>
                      <div className="head mt-40">
                        <h2 className="f18">
                          Your Attorney's Info{" "}
                          {/* <span style={{ fontSize: "16px", fontWeight: "500" }}>
                                                    (If you don't have one, leave blank)
                                                </span> */}
                        </h2>
                      </div>

                      <div
                        className={`col-lg-12 col-md-12 ${
                          values.agreeToBankruptcy && "mb-4"
                        }`}
                      >
                        <div
                          className="input_wrap checkbox-wrap"
                          style={{ marginBottom: "0px", marginTop: "30px" }}
                        >
                          <h1
                            className=""
                            style={{
                              fontSize: "17px",
                              padding: "0px 4px 20px 4px",
                            }}
                          >
                            Please confirm your attorney's contact details so
                            that we can send your certificate to your attorney.
                          </h1>
                          {!attorneyInfoAdded && (
                            <label
                              className="checkbox-label"
                              style={{
                                display: "flex",
                                alignItems: "baseline",
                                gap: "10px",
                              }}
                            >
                              <Field
                                type="checkbox"
                                name="agreeToBankruptcy"
                                className="checkbox-input"
                                onChange={(e) => {
                                  const isChecked = e.target.checked;
                                  setValues({
                                    ...values,
                                    agreeToBankruptcy: isChecked,
                                    ...(isChecked && {
                                      attorneyEmail: "",
                                      attorneyName: "",
                                      attorneyPhone: "",
                                    }),
                                  });
                                  if (isChecked) {
                                    setAtternyEmail("");
                                    setAtternyName("");
                                    setAtternyNumber("");
                                    setUserAttorney("");
                                    setReadOnly(false);
                                  }
                                }}
                              />

                              <p>
                                “ I do not have an attorney, but I have decided
                                that bankruptcy might be a good option for me.
                                Please connect me with an attorney in my state.
                                I understand that my information will be shared
                                with a third party for this purpose and have
                                read the
                                <span
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setShowDisclosureModal(true);
                                  }}
                                  style={{
                                    color: "#0d6efd",
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  Privacy & Disclosure Policy
                                </span>
                                <span style={{ paddingLeft: "5px" }}>“</span>
                              </p>
                            </label>
                          )}
                        </div>
                      </div>
                      {!values.agreeToBankruptcy && (
                        <fieldset
                          disabled={values.agreeToBankruptcy}
                          className="fieldset-disabled col-lg-12"
                        >
                          <div className="row">
                            <div className="row mt-20">
                              {!noCode && (
                                <div className="col-lg-4 col-md-6">
                                  <div className="input_wrap">
                                    {/* <label className="label-title">
                                                                    Enter Attorney Code
                                                                </label>
                                                                <Field
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={userAttorney}
                                                                    onChange={(e) => {
                                                                        setUserAttorney(e?.target?.value);
                                                                        setattCodeValidation(false);
                                                                    }}
                                                                    name="attycode"
                                                                    placeholder="Enter Attorney code"
                                                                    readOnly={readOnly}
                                                                />
                                                                 <ErrorMessage
                                                                name="attycode"
                                                                component="div"
                                                                className="error-message text-danger"
                                                            />
                                                                {attCodeValidation && (
                                                                    <p className="text-danger">
                                                                        Invalid Attorney Code{" "}
                                                                    </p>
                                                                )} */}
                                    <Field name="attycode">
                                      {({ field, form, meta }) => (
                                        <div className="input_wrap">
                                          <label className="label-title">
                                            Enter Attorney Code
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            {...field}
                                            value={userAttorney}
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              setUserAttorney(value); // your own state
                                              form.setFieldValue(
                                                "attycode",
                                                value
                                              ); // update Formik's state
                                              setattCodeValidation(false); // your extra validation flag
                                            }}
                                            placeholder="Enter Attorney code"
                                            readOnly={readOnly}
                                          />
                                          {meta.touched && meta.error && (
                                            <div className="error-message text-danger">
                                              {meta.error}
                                            </div>
                                          )}
                                          {attCodeValidation && (
                                            <p className="text-danger">
                                              Invalid Attorney Code
                                            </p>
                                          )}
                                        </div>
                                      )}
                                    </Field>
                                  </div>
                                </div>
                              )}
                              <div className="col-lg-6 col-md-6 collect-info-code-actions">
                                {!noCode && (
                                  <button
                                    className="btn_brnd-outline mr-22"
                                    disabled={verifyCodeloading || readOnly}
                                    type="button"
                                    onClick={()=>handleVerifyAttorney(
                                      values,
                                      setErrors,
                                      setTouched
                                    )}
                                  >
                                    {verifyCodeloading ? (
                                      <ThreeDots
                                        height="20"
                                        width="52"
                                        radius="9"
                                        color="#ed1717"
                                        ariaLabel="three-dots-loading"
                                        wrapperStyle={{
                                          display: "block",
                                        }}
                                        wrapperClassName="spinner"
                                        visible={true}
                                      />
                                    ) : (
                                      <>{readOnly ? "Verified" : "Verify"}</>
                                    )}
                                  </button>
                                )}
                                <button
                                  className="btn_brnd my-3"
                                  type="button"
                                  onClick={() => {
                                    setNoCode(!noCode);
                                    setReadOnly(false);
                                    setUserAttorney("");
                                    setAtternyName("");
                                    setAtternyEmail("");
                                    setAtternyNumber("");
                                     const formattedErrors = {};
                                     const touchedFields = {};
                                     setErrors(formattedErrors);
                                     setTouched(touchedFields);
                                    setValues({
                                      ...values, 
                                      attycode: "", 
                                    });
                                  }}
                                >
                                  {noCode ? "Add Code" : " No Code ?"}
                                </button>
                              </div>
                            </div>
                            <div className="row mt-20">
                              <div className="col-lg-4 col-md-6">
                                <div className="input_wrap">
                                  <label className="label-title">
                                    Attorney Email
                                  </label>
                                  <Field name="attorneyEmail">
                                    {({ field, form }) => (
                                      <input
                                        {...field}
                                        type="email"
                                        className="form-control"
                                        placeholder="Attorney Email"
                                        disabled={!noCode}
                                        value={atternyEmail}
                                        onChange={(e) => {
                                          setAtternyEmail(e.target.value);
                                          form.setFieldValue(
                                            "attorneyEmail",
                                            e.target.value
                                          );
                                        }}
                                      />
                                    )}
                                  </Field>
                                  <ErrorMessage
                                    name="attorneyEmail"
                                    component="div"
                                    className="error-message text-danger"
                                  />
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-6">
                                <div className="input_wrap">
                                  <label className="label-title">
                                    Attorney Name
                                  </label>
                                  <Field name="attorneyName">
                                    {({ field, form }) => (
                                      <input
                                        {...field}
                                        type="text"
                                        className="form-control"
                                        placeholder="Attorney Name"
                                        disabled={!noCode}
                                        value={atternyName}
                                        onChange={(e) => {
                                          setAtternyName(e.target.value);
                                          form.setFieldValue(
                                            "attorneyName",
                                            e.target.value
                                          );
                                        }}
                                      />
                                    )}
                                  </Field>
                                  <ErrorMessage
                                    name="attorneyName"
                                    component="div"
                                    className="error-message text-danger"
                                  />
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-6">
                                <div className="input_wrap">
                                  <label className="label-title">
                                    Attorney Phone
                                  </label>
                                  <Field name="attorneyPhone">
                                    {({ field, form }) => (
                                      <input
                                        {...field}
                                        type="text"
                                        className="form-control"
                                        placeholder="Attorney Phone"
                                        disabled={!noCode}
                                        value={atternyNumber}
                                        onChange={(e) => {
                                          setAtternyNumber(e.target.value);
                                          form.setFieldValue(
                                            "attorneyPhone",
                                            e.target.value
                                          );
                                        }}
                                      />
                                    )}
                                  </Field>
                                  <ErrorMessage
                                    name="attorneyPhone"
                                    component="div"
                                    className="error-message text-danger"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mb-4" style={{ textAlign: "center" }}>
                            <button
                              disabled={loadingAttorney || attorneyInfoAdded}
                              className="btn_brnd"
                              type="button"
                              style={{
                                width: "maxContent",
                                height: "maxContent",
                              }}
                              onClick={() =>
                                handleAddAttorney(
                                  values,
                                  setErrors,
                                  setTouched,
                                  noCode
                                )
                              }
                            >
                              {loadingAttorney ? (
                                <ThreeDots
                                  height="20"
                                  width="60"
                                  radius="9"
                                  color="#4fa94d"
                                  ariaLabel="three-dots-loading"
                                  wrapperStyle={{ display: "block" }}
                                  wrapperClassName="spinner"
                                  visible={true}
                                />
                              ) : noCode ? (
                                "Save Attorney"
                              ) : (
                                "Add Attorney"
                              )}
                            </button>
                          </div>
                        </fieldset>
                      )}
                    </>
                  )}
                  <div className="col-12" style={{ userSelect: "none" }}>
                    <div className="iagree_radio">
                      <input
                        type="checkbox"
                        name="isJointFiler"
                        id="joint"
                        onChange={handleCheckboxChange}
                        className=""
                        checked={showJointFiler}
                      />

                      {/* <label htmlFor="joint">Add a joint applicant</label> */}
                      <label htmlFor="joint">Add a joint filer</label>
                    </div>
                  </div>
                  {/* conditional rendering */}
                  {console.log("lskdfhaks", userData)}
                  {showJointFiler && (
                    <div>
                      <div className="head mt-40">
                        <h2 className="f18">Joint Applicant Info</h2>
                      </div>
                      <div className="row mt-40">
                        <div className="col-lg-6 col-md-6">
                          <div className="input_wrap">
                            <label className="label-title">First Name</label>
                            <Field
                              type="text"
                              className="form-control"
                              name="jointFiler_firstName"
                              placeholder="Enter your first name"
                              readOnly={jointReadOnly}
                            />
                            <ErrorMessage
                              name="jointFiler_firstName"
                              component="div"
                              className="error-message text-danger"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <div className="input_wrap">
                            <label className="label-title">
                              Middle Initial
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              name="jointFiler_middleInitial"
                              placeholder="Enter your middle name"
                              readOnly={jointReadOnly}
                            />
                            <ErrorMessage
                              name="jointFiler_middleInitial"
                              component="div"
                              className="error-message text-danger"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <div className="input_wrap">
                            <label className="label-title">Last Name</label>
                            <Field
                              type="text"
                              className="form-control"
                              name="jointFiler_lastName"
                              placeholder="Enter your last name"
                              readOnly={jointReadOnly}
                            />
                            <ErrorMessage
                              name="jointFiler_lastName"
                              component="div"
                              className="error-message text-danger"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <div className="input_wrap">
                            <label className="label-title">
                              Last Four Digits of SSN
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              name="jointFiler_ssn"
                              placeholder="Enter digit of SSN"
                              readOnly={jointReadOnly}
                            />
                            <ErrorMessage
                              name="jointFiler_ssn"
                              component="div"
                              className="error-message text-danger"
                            />
                          </div>
                        </div>
                        {/* <div className="col-lg-6 col-md-6">
                                         <div className="input_wrap">
                                           <label className="label-title">Phone Number</label>
                                           <Field
                                             type="text"
                                             className="form-control"
                                             name="joint_dlnum"
                                             placeholder="Enter your phone no."
                                             readOnly={jointReadOnly}

                                           />
                                           <ErrorMessage
                                             name="joint_dlnum"
                                             component="div"
                                             className="error-message text-danger"
                                           />
                                         </div>
                                       </div> */}
                        <div className="col-lg-6 col-md-6">
                          <div className="input_wrap">
                            <label className="label-title">
                              Joint Filer's Username
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              name="jointFiler_username"
                              placeholder="Enter your username"
                              readOnly={jointReadOnly}
                            />
                            <ErrorMessage
                              name="jointFiler_username"
                              component="div"
                              className="error-message text-danger"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <div className="input_wrap">
                            <label className="label-title">
                              Joint Filer's Password
                            </label>
                            <div className="collect-info-password">
                            <Field
                              id="joint-filer-password"
                              type={showAttymPass ? "text" : "password"}
                              className="form-control"
                              name="jointFiler_password"
                              placeholder="Enter your password"
                              readOnly={jointReadOnly}
                            />
                            <button
                              type="button"
                              className="collect-info-password-toggle"
                              aria-label={showAttymPass ? "Hide joint filer password" : "Show joint filer password"}
                              aria-controls="joint-filer-password"
                              aria-pressed={showAttymPass}
                              onClick={() => setShowAttymPass((visible) => !visible)}
                            >
                              {showAttymPass ? <FiEye aria-hidden="true" /> : <FiEyeOff aria-hidden="true" />}
                            </button>
                            </div>
                            <ErrorMessage
                              name="jointFiler_password"
                              component="div"
                              className="error-message text-danger"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <div className="input_wrap">
                            <label className="label-title">Date of Birth</label>
                            <Field name="joint_dob">
                              {({ field, form }) => (
                                <input
                                  type="date"
                                  className="form-control"
                                  style={{ height: "55px" }}
                                  name="joint_dob"
                                  value={field.value}
                                  onChange={field.onChange}
                                  onBlur={field.onBlur}
                                  readOnly={jointReadOnly}
                                />
                              )}
                            </Field>
                            <ErrorMessage
                              name="joint_dob"
                              component="div"
                              className="error-message text-danger"
                            />
                          </div>
                        </div>
                        <div className="mb-5" style={{ textAlign: "center" }}>
                          {!jointReadOnly && (
                            <button
                              disabled={loadingJointFiler || jointReadOnly}
                              className="btn_brnd"
                              type="button"
                              style={{
                                width: "maxContent",
                                height: "maxContent",
                              }}
                              onClick={() =>
                                handleAddJointFiler(
                                  values,
                                  setErrors,
                                  setTouched
                                )
                              }
                            >
                              {loadingJointFiler ? (
                                <ThreeDots
                                  height="20"
                                  width="60"
                                  radius="9"
                                  color="#4fa94d"
                                  ariaLabel="three-dots-loading"
                                  wrapperStyle={{ display: "block" }}
                                  wrapperClassName="spinner"
                                  visible={true}
                                />
                              ) : (
                                "Add Joint Filer"
                              )}
                            </button>
                          )}

                          {/* <span className="tooltips">
                                      click this button
                                    </span> */}
                        </div>
                      </div>
                    </div>
                  )}

                  <div
                    className={`col-lg-4 col-md-6 ${!showJointFiler && "collect-info-filing"}`}
                  >
                    <div className="input_wrap">
                      <label className="label-title">Filing State</label>
                      <Field name="filingState">
                        {({ field }) => (
                          <CollectInfoSelect
                            {...field}
                            value={selectedState}
                            onChange={(e) => {
                              setSelectedState(e.target.value);
                              setSelectedCounty("");
                              setSelectedDistrict("");
                              setValues({
                                ...values,
                                filingState: e.target.value,
                                filingCounty: "",
                                filingDistrict: "",
                              });
                            }}
                            className="form-control"
                          >
                            {statesData.length > 0 && (
                              <option value="">Select a State</option>
                            )}

                            {statesData.length > 0 ? (
                              statesData.map((state, index) => (
                                <option key={index} value={state.state}>
                                  {state.state}
                                </option>
                              ))
                            ) : (
                              <option value="">Loading...</option>
                            )}
                          </CollectInfoSelect>
                        )}
                      </Field>
                      <ErrorMessage
                        name="filingState"
                        component="div"
                        className="error text-danger"
                      />
                    </div>
                  </div>
                  {selectedState && (
                    <>
                      <div
                        className={`col-lg-4 col-md-6 ${
                          !showJointFiler && "collect-info-filing"
                        } `}
                      >
                        <div className="input_wrap">
                          <label className="label-title">Filing County</label>
                          <Field name="filingCounty">
                            {({ field }) => (
                              <CollectInfoSelect
                                {...field}
                                className="form-control"
                                value={selectedCounty}
                                onChange={(e) => {
                                  setSelectedCounty(e.target.value);
                                  setSelectedDistrict("");
                                  setValues({
                                    ...values,
                                    filingCounty: e.target.value,
                                    filingDistrict: "",
                                  });
                                }}
                              >
                                {countiesData.length > 0 && (
                                  <option value="">Select a county</option>
                                )}

                                {countiesData.length > 0 ? (
                                  countiesData.map((county, index) => (
                                    <option key={index} value={county.county}>
                                      {county.county}
                                    </option>
                                  ))
                                ) : (
                                  <option value="">Loading...</option>
                                )}
                              </CollectInfoSelect>
                            )}
                          </Field>
                          <ErrorMessage
                            name="filingCounty"
                            component="div"
                            className="error text-danger"
                          />
                        </div>
                      </div>

                      {selectedCounty && (
                        <div
                          className={`col-lg-4 col-md-6 ${
                            !showJointFiler && "collect-info-filing"
                          } `}
                        >
                          <div className="input_wrap">
                            <label className="label-title">
                              Filing District
                            </label>
                            <Field name="filingDistrict">
                              {({ field }) => (
                                <CollectInfoSelect
                                  {...field}
                                  className="form-control"
                                  value={selectedDistrict}
                                  onChange={(e) => {
                                    setSelectedDistrict(e.target.value);
                                    setValues({
                                      ...values,
                                      filingDistrict: e.target.value,
                                    });
                                  }}
                                >
                                  {districtsData.length > 0 && (
                                    <option value="">
                                      Select a Judicial District
                                    </option>
                                  )}

                                  {districtsData.length > 0 ? (
                                    districtsData.map((district, index) => (
                                      <option
                                        key={index}
                                        value={district.subdistrict}
                                      >
                                        {district.subdistrict ==
                                        "District of Oregon - Portland"
                                          ? "I live closer to Portland"
                                          : district.subdistrict ==
                                            "District of Oregon - Eugene"
                                          ? "I live closer to Eugene"
                                          : district.subdistrict}
                                        {/* {district.subdistrict} */}
                                      </option>
                                    ))
                                  ) : (
                                    <option value="">Loading...</option>
                                  )}
                                </CollectInfoSelect>
                              )}
                            </Field>
                            <ErrorMessage
                              name="filingDistrict"
                              component="div"
                              className="error text-danger"
                            />
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
                <div className="collect-info-submit">
                  <button
                    disabled={
                      loading ||
                      (!attorneyInfoAdded && userAttorney) ||
                      (!values?.agreeToBankruptcy &&
                        noCode &&
                        !attorneyInfoAdded) ||
                      (showJointFiler &&
                        !jointFilerInfoAdded &&
                        (values.jointFiler_firstName ||
                          values.jointFiler_lastName ||
                          values.joint_dob ||
                          values.jointFiler_ssn ||
                          //   values.joint_dlnum ||
                          values.jointFiler_username ||
                          values.jointFiler_password))
                    }
                    className={`btn_brnd ${
                      (!attorneyInfoAdded && userAttorney) ||
                      (!values?.agreeToBankruptcy &&
                        noCode &&
                        !attorneyInfoAdded) ||
                      (showJointFiler &&
                        !jointFilerInfoAdded &&
                        (values.jointFiler_firstName ||
                          values.jointFiler_lastName ||
                          values.joint_dob ||
                          values.jointFiler_ssn ||
                          // values.joint_dlnum ||
                          values.jointFiler_username ||
                          values.jointFiler_password))
                        ? "tooltip-for-complete-info"
                        : ""
                    }`}
                    type="button"
                    onClick={() =>
                      submitMainForm(values, setErrors, setTouched)
                    }
                  >
                    {loading ? (
                      <ThreeDots
                        height="20"
                        width="60"
                        radius="9"
                        color="#4fa94d"
                        ariaLabel="three-dots-loading"
                        wrapperStyle={{ display: "block" }}
                        wrapperClassName="spinner"
                        visible={true}
                      />
                    ) : (
                      "Complete my information"
                    )}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>

        {/* </Modal.Body>
                
            </Modal> */}
        {showDisclosureModal && (
          <DisclosureModal
            showModal={showDisclosureModal}
            setShowModal={setShowDisclosureModal}
          />
        )}
      </div>
    );
};

export default CollectInfoModal;
